import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'dealers',
            name: 'dealer',
            class: 'Modules\\Site\\Entities\\Dealer'
        }
    }
}